import { useDispatch, useSelector } from "react-redux";
import {
  GetFilters,
  SelectInitialStateFilters,
} from "../redux/reducers/timesConfirmationReport.reducer";
import { useCallback, useEffect } from "react";
import {
  IsLoading,
  loadTimeConfirmationInfo,
  SelectOrderedBy,
  setLoading,
} from "../redux/reducers/timesConfirmationResults.reducer";
import { TimesheetsService } from "../services/timesheets";
import { selectUserRoles } from "../../SharedModule/redux/reducers/auth.reducer";

export const useTimesConfirmationResults = () => {
  const dispatch = useDispatch();

  const isLoading = useSelector(IsLoading);
  const filters = useSelector(GetFilters);
  const initialStatefilters = useSelector(SelectInitialStateFilters);
  const { userRolesList } = useSelector(selectUserRoles);

  const { timeConfirmationUsersList } = useSelector(SelectOrderedBy);

  const loadTimeConfirmationResults = useCallback(async () => {
    dispatch(setLoading(true));
    const results = await TimesheetsService.getTimeConfirmationInfo({
      ...filters,
      costCentersIDs: filters.costCentersIDs
        ? filters.costCentersIDs.map((elem) => elem.value)
        : null,
    });
    dispatch(loadTimeConfirmationInfo(results));
  }, [dispatch, filters]);

  useEffect(() => {
    loadTimeConfirmationResults();
  }, [loadTimeConfirmationResults]);

  return {
    isLoading,
    filters,
    initialStatefilters,
    userRolesList,
    timeConfirmationUsersList,
  };
};
